export default {
    name: 'mine/suggest',
    path: 'suggest',
    component: () => import('./Root.vue')
}